<template lang='pug'>
div
  i.fa.fa-spinner.fa-spin.fa-4x.card-spinner(v-if="loading")
  div(v-else)
    .row.scale(v-if="score && scale")
      .col-12
        strong Bewertung:
      .scale-box
        span.scale-score(v-bind:class='{"scale-score-tab": tab}') {{score.toFixed(1).replace(".", ",")}}/5,0
      .benchmark-box
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt aller Unterhemen")
            span {{benchmark.toFixed(1).replace(".", ",")}}/5,0 Durchschnitt
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt der Unternehmen mit den zufriedensten Bewerbern")
            span {{best_experience.toFixed(1).replace(".", ",")}}/5,0 BestExperience
      .col-12(v-if="subtitle")
        .subtitle {{subtitle}}
    .row(v-else-if="score")
      .col-12
        strong Bewertung:
      .scale-box
        span.percent-score {{score.toFixed(1).replace(".", ",")}}%
      .benchmark-box
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt aller Unterhemen")
            i.fa.fa-lg.fa-fw.deviation-icon(:class="deviation_icon")
            span {{deviation}} als Durchschnitt
        .benchmark-text
          b-tooltip(effect="scale" placement="left" content="Durchschnitt der Unternehmen mit den zufriedensten Bewerbern")
            i.fa.fa-lg.fa-fw.deviation-icon(:class="deviation_icon_best_experience")
            span {{deviation_best_experience}} als BestExperience
      .col-12(v-if="subtitle")
        .subtitle {{subtitle}}
    .row(v-else)
      .col-12
        br
        .subtitle Keine Daten
</template>

<script>
  import { BTooltip } from 'bootstrap-vue'

  export default {
    components: { BTooltip },
    props: ['subtitle', 'score', 'benchmark', 'scale', 'loading', 'best_experience', 'tab'],
    computed: {
      deviation() {
        if (this.score > this.benchmark && this.benchmark != 0){
          return Math.round(this.score - this.benchmark) + "% mehr"
        }else{
          return Math.abs(Math.round(this.benchmark - this.score)) + "% weniger"
        }
      },
      deviation_icon() {
        if (this.score > this.benchmark && this.benchmark != 0){
          return "fa-arrow-up"
        }else{
          return "fa-arrow-down"
        }
      },
      deviation_best_experience() {
        if (this.score > this.best_experience && this.best_experience != 0){
          return Math.round(this.score - this.best_experience) + "% mehr"
        }else{
          return Math.abs(Math.round(this.best_experience - this.score)) + "% weniger"
        }
      },
      deviation_icon_best_experience() {
        if (this.score > this.best_experience && this.best_experience != 0){
          return "fa-arrow-up"
        }else{
          return "fa-arrow-down"
        }
      }
    }
  }
</script>

<style>
  .benchmark-box{
    float: left;
  }
  .scale-box{
    margin-left: 25px;
    min-height: 65px;
    width: 40%;
    float: left;
  }
  .card-spinner{
    margin: 20px;
  }
  .score{
    float: left;
    font-size: 36px;
  }
  .benchmark-text{
    margin-left: 18px;
    font-size: 11px;
    margin-top: 10px;
    color: rgb(92, 47, 132);
  }
  .scale-score{
    font-size: 42px;
  }
  .scale-benchmark{
    margin-left: 5px;
    font-size: 18px;
    color: rgb(92, 47, 132);
  }
  .scale-benchmark-label{
    margin-left: 5px;
    color: rgb(92, 47, 132);
  }
  .subtitle{
    font-size: 18px;
    min-height: 50px;
  }
  .percent-score{
    font-size: 42px;
  }
  @media (max-width: 1600px) {
    .scale-box{
      width: 100%;
    }
    .benchmark-box{
      margin-bottom: 20px;
    }
  }
  @media (max-width: 1200px) {
    .scale-score-tab{
      font-size: 20px;
    }
  }
</style>
